import React from 'react'

const OrderView = () => (
  <div className="quote">
    <h1>Order View</h1>
  </div>
)

export default OrderView